<template>
  <div>
    <tiptap-vuetify v-model="content" :extensions="extensions" />
  </div>
</template>

<script>
  import {
    // component
    TiptapVuetify,
    // extensions
    Heading,
    Bold,
    Italic,
    Strike,
    Underline,
    Code,
    CodeBlock,
    Paragraph,
    BulletList,
    OrderedList,
    ListItem,
    Link,
    Blockquote,
    HardBreak,
    HorizontalRule,
    History,
  } from "tiptap-vuetify";

  export default {
    props: ["html"],
    watch: {
      html: function () {
        this.content = this.html;
      },
    },
    components: { TiptapVuetify },
    mounted() {
      this.content = this.html;
    },
    data: () => ({
      extensions: [
        new Heading({
          levels: [1, 2, 3],
        }),
        new Bold(),
        new Italic(),
        new Strike(),
        new Underline(),
        new Code(),
        new CodeBlock(),
        new Paragraph(),
        new BulletList(),
        new OrderedList(),
        new ListItem(),
        new Link(),
        new Blockquote(),
        new HardBreak(), // Shift + Enter
        new HorizontalRule(),
        new History(),
      ],
      content: "",
    }),
  };
</script>

<style >
  .tiptap-vuetify-editor__menububble {
    display: none !important;
  }
</style>
